import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ContextProvider from './context/hooks/ContextProvider';
import { Toaster } from 'react-hot-toast';
import './index.css';
import "./styles/StyleColors.css"
import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <ContextProvider>
        <PrimeReactProvider>
          <App />
          <Toaster
            position="top-left"
            toastOptions={{
              style: {
                padding: '16px',
                fontSize: "16px",
                fontFamily: "sans-serif"
              },
            }}
          />
        </PrimeReactProvider>
      </ContextProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

